import { gql } from "@apollo/client";
import { IntegrationType } from "./companyIntegrationLimitation";

export const MAINTAIN_COMPANY_INTEGRATION_LIMITATIONS = gql`
mutation MaintainCompanyIntegrationLimitations($domain: String!, $creates: [Int!]!, $deletes: [Int!]!) {
  company {
    maintainCompanyIntegrationLimitations(domain: $domain, creates: $creates, deletes: $deletes) {
      message
      code
      success
      updatedValues {
        integration_type_id
        integration_name
        description
        access_level
      }
    }
  }
}
`

export interface MaintainCompanyIntegrationLimitationsResponse {
  company: {
    maintainCompanyIntegrationLimitations: {
      message: string
      code: string
      success: boolean
      updatedValues?: IntegrationType[]
    }
  }
}

export interface MaintainCompanyIntegrationLimitationsArgs {
  domain: string;
  creates: number[];
  deletes: number[];
}
